// toaster
export const SHOW_TOASTER = "SHOW_TOASTER";
export const HIDE_TOASTER = "HIDE_TOASTER";

// backdrop
export const SHOW_BACKDROP = "SHOW_BACKDROP";
export const HIDE_BACKDROP = "HIDE_BACKDROP";
